import {Link} from 'react-router-dom';
import Logo from '../.././../assets/image/dashboard/shop-logo.svg';

import styles from './header.module.scss';
const ShopHeader = () => {
  return (
    <>
      <div className={styles['header-logo']}>
        <div className="d-flex align-items-center p-3 px-3 justify-content-between ">
          <div className="d-flex align-items-center ">
            <img src={Logo} alt="logo" />
            <h6 className="m-0 pe-2 fw-bold color-primary">فروشگاه مزرعه</h6>
          </div>
          <Link to="/dashboard">
            <i className="icon-home color-gray-1 fs-4"></i>
          </Link>
        </div>
      </div>
    </>
  );
};

export default ShopHeader;
